function getEntityNavigationId(target: EventTarget | null): string | null {
  const element = target instanceof HTMLElement ? target : null;
  const linked = element?.closest?.("[data-entity-id]") as HTMLElement | null;
  return linked?.getAttribute("data-entity-id") ?? null;
}

export function handleEntityLinkMouseDown(event: MouseEvent): boolean {
  const id = getEntityNavigationId(event.target);
  if (!id) {
    return false;
  }

  event.preventDefault();
  event.stopPropagation();
  return true;
}

export function handleEntityLinkClick(event: MouseEvent, navigateToEntity: (id: string) => void): boolean {
  const id = getEntityNavigationId(event.target);
  if (!id) {
    return false;
  }

  event.preventDefault();
  event.stopPropagation();
  navigateToEntity(id);
  return true;
}
